// @ts-nocheck

import React, { useMemo } from 'react';
import { navigatorTo } from '../../utils/util';

interface IGalleryJumperWithName {
  gallery: any;
}

const PrefixIMG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      version="1.1"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <defs>
        <clipPath id="master_svg0_183_17970">
          <rect x="0" y="0" width="16" height="16" rx="0" />
        </clipPath>
      </defs>
      <g clipPath="url(#master_svg0_183_17970)">
        <path
          d="M14.422805640625,1.000029802322L4.460306410625,1.000029802322C4.141500230625,1.000029921532,3.883056640625,1.25847352,3.883056640625,1.57727993C3.883056640625,1.89608622,4.141500230625,2.1545297999999997,4.460306410625,2.1545297999999997L13.845556240625,2.1545297999999997L13.845556240625,11.228029C13.845556240625,11.546835,14.103999640625,11.805279,14.422806640625,11.805279C14.741612640625,11.805279,15.000056640625,11.546835,15.000056640625,11.228029L15.000056640625,1.5772798099999998C15.003293640625,1.25714147,14.742943640625,0.9967915416,14.422805640625,1.000029802322Z"
          fill="#FFFFFF"
          fillOpacity="1"
          style={{ mixBlendMode: 'passthrough' }}
        />
        <path
          d="M12.61323471875,2.797881364822L1.5772345087500002,2.797881364822C1.2570967687499999,2.7946438789,0.99674713615,3.0549936325,0.99998450279,3.3751313725L0.99998450279,14.4111305625C0.99807620045,14.4499895625,1.00195181365,14.4889145625,1.01148450375,14.5266325625C1.01148450375,14.5381315625,1.02298450475,14.5613825625,1.02298450475,14.5728815625C1.03448450575,14.5958825625,1.03448450575,14.6076315625,1.04598450675,14.6306325625C1.05748450775,14.6536315625,1.06898450875,14.6653825625,1.08073449175,14.6883815625C1.09223449275,14.6998825625,1.09223449275,14.7231315625,1.10373448875,14.7346325625C1.14856958875,14.7967685625,1.20309793875,14.8512975625,1.2652344687500001,14.8961315625C1.27673446875,14.9076325625,1.29998445875,14.9076325625,1.31148445875,14.9191325625C1.33448445875,14.9306315625,1.34623443875,14.9421305625,1.36923443875,14.9538825625C1.39223444875,14.9656315625,1.40398442875,14.9653815625,1.42698442875,14.9768805625C1.43848442875,14.9768805625,1.4617344187499999,14.9883825625,1.47323441875,14.9883825625C1.51095234875,14.9979155625,1.5498772887499999,15.0017905625,1.5887343887499998,14.9998815625L12.62498471875,14.9998815625C12.94492571875,15.0029775625,13.20507771875,14.7428245625,13.20198471875,14.4228825625L13.20198471875,3.3751313725C13.18765271875,3.0580163025,12.93057071875,2.8059556484,12.61323471875,2.797881364822ZM12.03598371875,3.9523813624999997L12.03598371875,6.7113814625L7.71848391875,11.0288810625L6.33323381875,9.6436314625C6.22603031875,9.5358233625,6.08123491875,9.4737295625,5.92923351875,9.4703812625C5.77612881875,9.4684147625,5.62934871875,9.5313601625,5.52523421875,9.6436314625L2.15448451875,13.0143815625L2.15448451875,3.9523813624999997L12.03598371875,3.9523813624999997ZM2.96248461875,13.8453805625L5.92923451875,10.8786315625L7.31448461875,12.2638816625C7.53892231875,12.4948615625,7.90979571875,12.4948615625,8.134234418750001,12.2638816625L12.03623371875,8.3618807625L12.03623371875,13.8453805625L2.96248461875,13.8453805625Z"
          fill="#FFFFFF"
          fillOpacity="1"
          style={{ mixBlendMode: 'passthrough' }}
        />
        <path
          d="M4.7104778390625,8.661922475C5.5712137390625,8.661922475,6.2689776390625,7.964158075,6.2689776390625,7.103422175C6.2689776390625,6.242686275,5.5712137390625,5.544921875,4.7104778390625,5.544921875C3.8497419390625,5.544921875,3.1519775390625,6.242686275,3.15197777748108,7.103422175C3.1523911952925,7.963986875,3.8499131190625,8.661508575,4.7104778390625,8.661922475ZM4.7104778390625,6.456922535C5.0611786390625,6.456922535,5.3454775390625,6.741221475,5.3454775390625,7.091922275C5.3454775390625,7.442623175,5.0611786390625,7.726922475,4.7104778390625,7.726922475C4.3597769390625,7.726922475,4.0754775990625,7.442623575,4.0754775990625,7.0919227750000005C4.0784659390625,6.742466975,4.3610220390625,6.459910395,4.7104778390625,6.456922535Z"
          fill="#FFFFFF"
          fillOpacity="1"
          style={{ mixBlendMode: 'passthrough' }}
        />
      </g>
    </svg>
  );
};

const GalleryJumperWithName = ({ gallery }: IGalleryJumperWithName) => {
  const link = useMemo(() => {
    console.log('gallery', gallery);
    if (gallery?.is_exhibitor === 1) {
      return {
        type: 'exhibitor',
        value: gallery?.exhibitor_detail?.id,
      };
    } else {
      return {
        type: 'gallery',
        value: gallery?.link,
      };
    }
  }, [gallery]);

  const galleyName = gallery?.name || gallery?.galleryname || '';

  //  如果有相册，但装修页无对应页面 → - 则隐藏左下角相册入口，避免用户点击。直到有对应装修页面
  const isGalleryAndHasNoLinkId =
    gallery?.is_exhibitor === 0 && !gallery?.link;

  if (isGalleryAndHasNoLinkId) {
    return null;
  }

  const isExhibitorAndStatusIsZero = gallery?.is_exhibitor === 1 && gallery?.exhibitor_detail?.status === 0;

  if (isExhibitorAndStatusIsZero) {
    return null;
  }

  return (
    <span
      className="bigpic-top-info"
      onClick={() => {
        navigatorTo(link);
      }}
    >
      <span className="bigpic-top-info-label">
        <span className="bigpic-top-info-prefix">
          <PrefixIMG />
        </span>
        <span className="bigpic-top-info-name">{galleyName}</span>
      </span>
      <span className="bigpic-top-info-arrow" aria-hidden="true" />
    </span>
  );
};

export default GalleryJumperWithName;
